import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';
import { getScreens, type IScreensReadParams, AtomicItemListType } from 'shared/src/api';
import { useFilterListAtom } from 'shared/src/component/AtomicRenderer/ItemList/FilterList/Provider/filterList/useFilterListAtom';

export const useGetTodayScreensInfiniteQuery = (
  screenName: string,
  nextToken?: string,
) => {
  const {
    filterListAtomValue: { ...restFilterListAtomValue },
  } = useFilterListAtom();

  return useInfiniteQuery({
    queryKey: [
      'getScreens',
      { ...restFilterListAtomValue, nextToken, screen_name: screenName },
    ],
    queryFn: ({ pageParam }) => {
      const requestParams = {
        ...restFilterListAtomValue,
        next_token: pageParam ?? null,
        screen: screenName,
      } as IScreensReadParams;
      return getScreens(requestParams);
    },
    enabled: true,
    initialPageParam: nextToken ?? null,
    getNextPageParam: lastPage => {
      return lastPage.nextToken || undefined;
    },
    select: data => {
      const components = data.pages.flatMap(page => page.components);
      const splitComponents = components.flatMap(component => {
        if (
          component.type.itemList === AtomicItemListType.FilterList &&
          component.type.header !== null
        ) {
          return [
            {
              ...component,
              type: {
                ...component.type,
                itemList: null,
              },
              entity: {
                ...component.entity,
                itemList: null,
              },
            },
            {
              ...component,
              type: {
                ...component.type,
                header: null,
              },
              entity: {
                ...component.entity,
                header: null,
              },
            },
          ];
        }
        return [component];
      });

      return {
        ...data.pages[data.pages.length - 1],
        components: splitComponents,
      };
    },
    placeholderData: keepPreviousData,
  });
};
